import React, { useContext } from "react"
import CloudinaryImage from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Images/CloudinaryImage"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTrashCan } from "@fortawesome/sharp-light-svg-icons"

import ProductAmountStepper from "../atoms/ProductAmountStepper"
import NexmartCartContext from "../../context/NexmartCartContext"

import { useTranslation } from "react-i18next"

const CartItem = ({ item }) => {
  const { removeItem, decreaseItemQuantity, setItemQuantity } =
    useContext(NexmartCartContext)

  const { t } = useTranslation()

  if (item.quantity > 0) {
    return (
      <div className="py-8 border-t border-ro-gray-100">
        <div className="flex flex-row flex-wrap">
          <div className="w-1/6">
            <CloudinaryImage
              fillColor="ffffff"
              aspectRatio="1by1"
              image={item.image || process.env.GATSBY_IMG_PLACEHOLDER}
              lazyLoad={false}
            />
          </div>
          <div className="w-5/6 pl-8">
            <div>
              <h3 className="headline">{item.name}</h3>
              <span className="block mt-2">
                {t("generic.products.no")} {item.externalKey}
              </span>
            </div>
            <div className="hidden w-full mt-6 md:block">
              <span className="block mb-2 text-ro-gray-600 text-sm leading-[1.125rem]">
                {t("generic.cart.amount")}
              </span>
              <div className="flex flex-row justify-between">
                <div>
                  <ProductAmountStepper
                    id={`amount-stepper-cart-item-${item.externalKey}`}
                    label="Anzahl"
                    inputValue={item.quantity}
                    min={1}
                    max={99}
                    step={1}
                    onDecrement={() => decreaseItemQuantity(item.externalKey)}
                    onIncrement={(e) => setItemQuantity(item.externalKey, e)}
                    setQuantity={(e) => setItemQuantity(item.externalKey, e)}
                  />
                </div>
                <div>
                  <button
                    className="border border-transparent btn text-ro-red hover:text-ro-white hover:bg-ro-red-600 hover:border-ro-red-600 active:text-ro-white active:bg-ro-red-800 active:border-ro-red-800"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault()
                      removeItem(item.externalKey)
                    }}
                  >
                    {t("generic.cart.remove_item")}
                    <FontAwesomeIcon
                      icon={faTrashCan}
                      size="1x"
                      className="inline-block ml-3 -mt-1"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full mt-4 md:hidden">
            <span className="block mb-2 text-ro-gray-600 text-sm leading-[1.125rem]">
              {t("generic.cart.amount")}
            </span>
            <div className="flex flex-row justify-between">
              <div>
                <ProductAmountStepper
                  id={`amount-stepper-cart-item-${item.externalKey}`}
                  label="Anzahl"
                  inputValue={item.quantity}
                  min={1}
                  max={99}
                  step={1}
                  onDecrement={() => decreaseItemQuantity(item.externalKey)}
                  onIncrement={(e) => setItemQuantity(item.externalKey, e)}
                  setQuantity={(e) => setItemQuantity(item.externalKey, e)}
                />
              </div>
              <div>
                <button
                  className="btn text-ro-red"
                  type="button"
                  onClick={(e) => {
                    e.preventDefault()
                    removeItem(item.externalKey)
                  }}
                >
                  <FontAwesomeIcon
                    icon={faTrashCan}
                    size="1x"
                    className="inline-block ml-2 -mt-1"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  } else {
    return <></>
  }
}

export default CartItem
